import type { ReactNode } from 'react';

/**
 * The workspace's shared async write-outcome banner (WCAG 2.2 SC 4.1.3 Status Messages):
 * `tone="error"` renders `role="alert"` (an implicit `aria-live="assertive"` region, announced
 * immediately on mount without moving focus); `tone="success"` renders `role="status"` (an
 * implicit `aria-live="polite"` region). Every consumer conditionally MOUNTS this component only
 * once a write outcome exists (`{apiError && <FormFeedback ...>}`), so mounting itself is what
 * triggers the assistive-technology announcement — no `aria-live` toggling needed.
 */
export function FormFeedback({
  tone,
  id,
  className,
  children,
}: {
  tone: 'error' | 'success';
  id?: string;
  className?: string;
  children: ReactNode;
}) {
  if (tone === 'error') {
    return (
      <p id={id} role="alert" className={className ?? 'text-destructive text-sm'}>
        {children}
      </p>
    );
  }
  return (
    <p id={id} role="status" className={className ?? 'text-success text-sm'}>
      {children}
    </p>
  );
}
